import React, {useEffect, useState} from 'react';
import { DndProvider, useDrag, useDrop } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import {TT_DELETE, TT_VIEW} from "../i18n/toolTips";
import { GenericTableButton } from "../buttons/buttonsActions";
import {showToastCustom} from "../toast/customToast";
import {error} from "../i18n/i18n";
import {GenericButton} from "../buttons/customButtons";

const DragItem = ({ item, index, moveItem, removeItem, selectItem, renderContent, onRemoveFromList, onSelect }) => {

    const [, ref] = useDrag({
        type: 'ITEM',
        item: { index },
    });

    const [, drop] = useDrop({
        accept: 'ITEM',
        hover(hoverItem) {
            if (hoverItem.index === index) return;

            moveItem(hoverItem.index, index);
            hoverItem.index = index;
        },
    });

    const handleCheckboxChange = (event) => {
        onSelect(event.target.checked, item, index); // Notify parent of checkbox state
    };

    return (
        <div ref={(node) => ref(drop(node))} className={'draggable-item'}>
            <input
                type="checkbox"
                onChange={handleCheckboxChange}
                style={{marginRight: '10px'}}
                checked={item.isSelected || false}
            />

            <GenericButton
                style={'danger-secondary'}
                toolTip={'Remover de la lista'}
                icon={'fa-minus'}
                permission={'delete'}
                onClick={() => onRemoveFromList(index)}
            />

            {/*<GenericTableButton toolTip={TT_DELETE} icon={'fa-trash'} permission={'delete'} onClick={() => removeItem(item, index)}/>*/}
            <GenericTableButton toolTip={TT_VIEW} icon={'fa-eye'} permission={'edit'} onClick={() => selectItem(item)}/>
            <br/>
            <span>
                Id: <b>{(item?.id || '').toString().toUpperCase()}</b>
                <br/>
                <br/>
                Orden: <b>{item.showOrder}</b>  &nbsp;&nbsp;&nbsp;    Original: <b>{item.originalOrder}</b>
                <br/>
                {'lat:'} <b>{(item?.position?.lat?.toFixed(6) || 0.0)} </b> {', lng:'} <b> {(item?.position?.lng?.toFixed(6) || 0.0)}</b> {', alt:'} <b> {(item.position?.alt?.toFixed(6) || 0.0)}</b>
            </span>
        </div>
    );
};

export const DragList = ({items, renderContent, onReorder, onRemove, onSelect, onRemoveFromList}) => {
    const [itemList, setItemList] = useState(items || []);

    useEffect(() => {
        if (items.length)
            setItemList(items);

        // if (selectedItem !== null)

    }, [items]);

    const moveItem = (fromIndex, toIndex) => {
        const updatedItems = [...itemList];
        const [movedItem] = updatedItems.splice(fromIndex, 1);
        updatedItems.splice(toIndex, 0, movedItem);

        const reorderedList = updatedItems.map((item, index) => ({ ...item, showOrder: index + 1 }))
        setItemList(reorderedList);
        onReorder( {from : fromIndex, to : toIndex, list : reorderedList } );
    };

    const removeItem = (item, index) => {
        onRemove(index)
            .then(_ => {

                const updatedItems = [...itemList];
                updatedItems.splice(index, 1);

                setItemList(updatedItems.map((item, index) => ({ ...item, showOrder: index + 1 })));
            })
            .catch(errorMessage => {
                showToastCustom(error, errorMessage);
            })
            .finally(_ => {
            });
    };

    const selectItem = (item) => {
        // const updatedItems = [...itemList];
        // updatedItems.splice(index, 1);
        //
        // setItemList(updatedItems.map((item, index) => ({ ...item, showOrder: index + 1 })));
        onSelect(item);
    };

    // console.log(itemList);
    return (
        <DndProvider backend={HTML5Backend}>
            <div className={'draggable-item-container'}>
                {itemList
                    //.sort((a, b) => a[orderKey] - b[orderKey])
                    //.sort((a, b) => a.showOrder - b.showOrder)
                    .map((item, index) => (
                        <DragItem key={index}
                                  index={index}
                                  item={item}
                                  moveItem={moveItem}
                                  removeItem={removeItem}
                                  onRemoveFromList={onRemoveFromList}
                                  onSelect={onSelect}
                                  renderContent={renderContent} />
                    ))}
            </div>
        </DndProvider>
    );
};